import React, { useState } from 'react';
import PhysicalCopyModal from './PhysicalCopyModal';
import { IPhysicalCopyDataroom } from './IPhysicalCopyDataroom';

export default function usePhysicalCopyModal() {
  const [dataroomItem, setDataroomItem] = useState<IPhysicalCopyDataroom | null>(null);

  const showPhysicalCopyModal = (item: IPhysicalCopyDataroom | null) => {
    setDataroomItem(item);
  };

  const hidePhysicalCopyModal = () => {
    setDataroomItem(null);
  };

  const Modal = (props: any) => (props.dataroom ? <PhysicalCopyModal { ...props } /> : null);

  return {
    Modal,
    dataroomItem,
    showPhysicalCopyModal,
    hidePhysicalCopyModal,
  };
}
